import { render, staticRenderFns } from "./LapidusResidentsSetup.vue?vue&type=template&id=309a7d98&"
import script from "./LapidusResidentsSetup.vue?vue&type=script&lang=js&"
export * from "./LapidusResidentsSetup.vue?vue&type=script&lang=js&"
import style0 from "./LapidusResidentsSetup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports